import { Component, OnDestroy } from '@angular/core';
import { ExpansionService } from '../../../../services/ui/expansion.service';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-description-toggle',
  templateUrl: './description-toggle.component.html',
  styleUrls: ['./description-toggle.component.scss'],
})
export class DescriptionToggleComponent implements OnDestroy {
  private subscriptions = new Subscription();
  descriptionsVisibleFormControl: FormControl = new FormControl(true);

  constructor(private expansionService: ExpansionService) {
    this.subscriptions.add(
      this.descriptionsVisibleFormControl.valueChanges.subscribe(value =>
        this.expansionService.setDescriptionsExpanded(value)
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
